
import { Component, ElementRef, OnInit } from '@angular/core';
import { providerDataUpdateService } from './provider-data-update.service';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { Router, ActivatedRoute } from '@angular/router';
import { urlProps } from '../../common/model/urls';
import { ConfigProvider } from '../../shared/services/configprovider';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, RequiredValidator, Validators, FormArray, FormGroup } from '@angular/forms';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'app-provider-data-update',
    templateUrl: './provider-data-update.component.html',
    styleUrls: ['./provider-data-update.component.scss'],
    standalone: false
})
export class ProviderDataUpdateComponent implements OnInit {
  providerData: any[];
  showSpinner = false;
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  sites = [];
  showView: boolean;
  siteProviderConfig: any;
  providerId: any;
  name: any;
  campaignId = 0;
  instanceId = 0;
  mode = 5;
  recall: boolean = false;
  list: any[] = [];
  loading = false;
  p: number = 1;
  searchInput: string;
  data = [];
  copyOfList: any[] = [];
  public dataUpdateForm: UntypedFormGroup;
  public aoeOptions: any[] = [];
  selectedAOEOptions: any[] = [];
  selectedAOEOptionsValue: any[] = [];
  public providerLanguageOptions: any[] = [];
  selectedProviderLanguageOptions: any[] = [];
  selectedProviderLanguageOptionsValue: any[] = [];
  public staffLanguageOptions: any[] = [];
  staffProviderLanguageOptions: any[] = [];
  staffProviderLanguageOptionsValue: any[] = [];
  public officeHoursOptions: any[] = [];
  selectedOfficeHours: any[] = [];
  selectedOfficeHoursValue: any[] = [];
  public provierIdOptions: any[] = [];
  selectedProviderId: any[] = [];
  panelStatus: any[] = [];
  selectedProviderIdValue: any[] = [];
  pcpDropdownforDCE:any;
  selectedProviderModel:any;
  submitted = false;
  startTime: any[] = [];
  endTime: any[] = [];
  selectDay: any[] = [];
  endTimeFlag:boolean = false;
  NewPDM: boolean = false;
  officeHours: boolean = true;
  isTermDateDisabled: boolean = true;
  handleResults(searchObj) {
    this.data = searchObj;
  }

  ngOnInit() {
    this.getProviderInfo();
    this.loadMetadata();
    this.createDataUpdateForm();
  }

  constructor(
    private cupService: CupService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlconstantsService: UrlconstantsService,
    private providerDataUpdateService: providerDataUpdateService,
    private configProvider: ConfigProvider,
    private fb: UntypedFormBuilder) {}


    private createDataUpdateForm() {
        this.dataUpdateForm = this.fb.group({
          provierIdFormControl: ['',[Validators.required]],
          planTermFormControl: [''],
          panelStatusFormControl: ['',[Validators.required]],
          termDateFormControl: [''],
          provierLanguageFormControl: [''],
          effectiveDateFormControl: [''],
          staffLanguageFormControl: [''],
          taxidFormControl: ['',[Validators.required,Validators.maxLength(9)]],
          aoeFormControl: [''],
          streetFormControl: [''],
          suiteFormControl: [''],
          cityFormControl: [''],
          stateFormControl: [''],
          zipCodeControl: [''],
          officeHoursFormControl: [''],
          phoneFormControl: [''],
          faxFormControl: [''],
          formerAddressFormControl: [''],
          timecheck: this.fb.array([
            this.fb.group ({
              daySelectControl: [''],
              startTimeControl: [''],
              endTimeControl: [''],
            })
          ])
        });
    }

    onZipCodeInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      const numericValue = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
      input.value = numericValue;
      this.dataUpdateForm.controls.zipCodeControl.setValue(input.value);
    }

    onTaxIdInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      const numericValue = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
      input.value = numericValue;
      this.dataUpdateForm.controls.taxidFormControl.setValue(input.value);
    }

    clearSelectOptions(){
      this.dataUpdateForm.controls.provierIdFormControl.setValue('');
      this.dataUpdateForm.controls.planTermFormControl.setValue('');  
      this.dataUpdateForm.controls.panelStatusFormControl.setValue('');
      this.dataUpdateForm.controls.formerAddressFormControl.setValue('');
      const timecheckArray = this.dataUpdateForm.get('timecheck') as FormArray;
      timecheckArray.controls.forEach(group => {
        (group as FormGroup).controls.daySelectControl.setValue('');
      });
    }

    clearForm(){
      this.submitted = false;
      this.dataUpdateForm.reset();
      this.clearSelectOptions();
    }

    toggleValueEvent(event : any){
      this.officeHours = event.target.value === 'daily'
    }
    get provierIdFormControl() {
      return this.dataUpdateForm.get('provierIdFormControl');
    } 
    get panelStatusFormControl() {
      return this.dataUpdateForm.get('panelStatusFormControl');
    } 
    
    get taxidFormControl() {
      return this.dataUpdateForm.get('taxidFormControl');
    } 
    get termDateFormControl() {
      return this.dataUpdateForm.get('termDateFormControl');
    } 

    get timecheck() : UntypedFormArray {
      return this.dataUpdateForm.get("timecheck") as UntypedFormArray
    }
   
    newTime(): UntypedFormGroup {
      return this.fb.group({
        daySelectControl: [''],
        startTimeControl: [''],
        endTimeControl: [''],
      })
    }
   
    addTime() {      
      this.timecheck.push(this.newTime());      
    }
   
    removeTime(i:number) {
      this.timecheck.removeAt(i);
      if(this.startTime.length || this.endTime.length) {
        if(this.startTime.length) {
          const index = this.startTime.indexOf(this.startTime[i].index)
          const x = this.startTime.splice(index, 1);
        }
        if(this.endTime.length) {          
          const index = this.endTime.indexOf(this.endTime[i].index)
          const x = this.endTime.splice(index, 1);
        }
      }
    }   
    
    
    onSelectionChange(event:Event):void {
      // console.log
      const selectedEvent = event.target as HTMLSelectElement
      const selectedValue = selectedEvent.value
      if (selectedValue === 'Yes') {
        this.isTermDateDisabled = false;
        this.dataUpdateForm.controls.termDateFormControl.setValidators([Validators.required])
      }  
      if (selectedValue === 'No') {
        this.isTermDateDisabled = true;
        this.dataUpdateForm.controls.termDateFormControl.clearValidators();
      }  


      if(this.isTermDateDisabled){
        this.dataUpdateForm.controls.termDateFormControl.disable();
        } else {
          this.dataUpdateForm.controls.termDateFormControl.enable();
      }
      this.dataUpdateForm.controls.termDateFormControl.updateValueAndValidity();
    }
    onSelectionDay(event,ind){
      this.selectDay.push({
        index:ind,
        value:event.target.value
      })
    }
    onSelectionStartTime(event,ind) {
      let updateRecord = false;    
      if(this.startTime.length > 0) {
        for (let i=0;i<this.startTime.length;i++) {
          if (this.startTime[i].index == ind) {
            updateRecord = true;
            this.startTime[ind].value = event.target.value;            
          }      
        }
         if (updateRecord != true) {
            this.startTime.push({
              index:ind,
              value:event.target.value
            })
          }         
       }
      else {
        this.startTime.push({
          index:ind,
          value:event.target.value
        })
      }
      if(this.selectDay.length <= 0 || this.selectDay[ind] == undefined) {
        alert('Please select day')
        this.timecheck.controls[ind].patchValue({
          'startTimeControl':''
        }); 
        this.startTime[ind].value = event.target.value;
      }      
      updateRecord = false;
    }
    onSelectionEndTime(event,ind) {
      let updateRecord = false;
      if(this.endTime.length > 0) {
        for (let i=0;i<this.endTime.length;i++) {
          if (this.endTime[i].index == ind) {
            updateRecord = true;
            this.endTime[ind].value = event.target.value;            
          }      
        }
         if (updateRecord != true) {
            this.endTime.push({
              index:ind,
              value:event.target.value
            })
          }
       }
      else if(this.startTime.length > 0) {
        this.endTime.push({
          index:ind,
          value:event.target.value
        })
      }
      updateRecord = false;
      
      if(this.startTime.length > 0 && this.endTime.length > 0 ) {
        if(this.startTime[ind] && this.endTime[ind]) {
          if (this.startTime[ind].value >= this.endTime[ind].value ) {
            alert('End time should be greater then start time')
            this.timecheck.controls[ind].patchValue({
              'endTimeControl':''
            }); 
            this.endTime[ind].value = event.target.value;
            }  
        }
        else if(this.startTime[ind] == undefined) {
          alert('Please enter start time');
          this.timecheck.controls[ind].patchValue({
            'endTimeControl':''
          }); 
          this.endTime[ind].value = event.target.value;
          return;
        }
     
      }
      else {
        alert('Please enter start time');
        this.timecheck.controls[ind].patchValue({
          'endTimeControl':''
        }); 
        this.endTime[ind].value = event.target.value;
        return;
      }
    }


    onPhoneKeyUp(event: any) {
      const inputValue: string = event.target.value;
      const numberValue = this.extractNumber(inputValue);
      const formattedPhone = this.constructPhoneFormat(numberValue);
      //this.model[event.target.name] = formattedPhone;
      event.target.value = formattedPhone;
    }
    onPhoneKeyUp1(event: any) {
      const inputValue: string = event.target.value;
      const numberValue = this.extractNumber(inputValue);
      const formattedPhone1 = this.constructPhoneFormat1(numberValue);
      //this.model[event.target.name] = formattedPhone;
      event.target.value = formattedPhone1;
    }
  
    extractNumber(value: string) {
      let newVal = '';
      if (isNaN(Number(value))) {
        for (let i = 0; i < value.length; i++) {
          const s: string = value.charAt(i);
          if (!isNaN(Number(s)) && s !== ' ') {
            newVal += s;
          }
        }
      } else {
        newVal = value;
      }
      return newVal;
    }
  
    constructPhoneFormat(value: string) {
      let newVal = value;
      if (value.length >= 4) {
        newVal = '(' + value.substring(0, 3) + ')';
        newVal += '-' + value.substring(3, (value.length <= 6) ? value.length : 6);
        if (value.length > 6) {
          newVal += '-' + value.substring(6, (value.length <= 10) ? value.length : 10);
        }
      }      
      return newVal;
    }
    constructPhoneFormat1(value: string) {
      let newVal = value;
      if (value.length >= 5) {
        newVal =  value.substring(0, 5) ;
        newVal += '+';
        if (value.length > 4) {
          newVal += value.substring(5, (value.length <= 9) ? value.length : 9);
        }
      }      
      return newVal;
    }
  
    decimalRestrict(event: any) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode !== 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
    submitForm(formControls){
      this.selectedAOEOptionsValue = [];
      this.selectedProviderLanguageOptionsValue = [];
      this.staffProviderLanguageOptionsValue = [];
      this.selectedProviderIdValue = [];
      let temp = [];
      this.selectedOfficeHoursValue = [];
      this.submitted = true;
      
      if(this.selectedProviderId){
        this.selectedProviderIdValue.push(this.selectedProviderId["value"])
      }
      
      
      
      temp = this.dataUpdateForm.value.timecheck;
      var names = temp.map(function(item,index) {
        let i = index+1;        
        return ("TimeSlot "+i+" : "+item['daySelectControl']+" "+item['startTimeControl']+" - "+item['endTimeControl']);
        });
                
        this.selectedOfficeHoursValue = names; 
        
        if(this.selectedProviderLanguageOptions) {
          this.selectedProviderLanguageOptions.filter(item => {
            this.providerLanguageOptions.filter((element) => {
              if(element.value == item){
                this.selectedProviderLanguageOptionsValue.push(element.label)
              }             
            })
          })
        }
        if(this.staffProviderLanguageOptions) {
          this.staffProviderLanguageOptions.filter(item => {
            this.staffLanguageOptions.filter((element) => {
              if(element.value == item){
                this.staffProviderLanguageOptionsValue.push(element.label)
              }             
            })
          })
        }
        if(this.selectedAOEOptions) {
          this.selectedAOEOptions.filter(item => {
            this.aoeOptions.filter((element) => {
              if(element.value == item){
                this.selectedAOEOptionsValue.push(element.label)
              }             
            })
          })
        }
      let fileObj;
      
      fileObj = {
        "addressEffDate": this.formatDate(this.dataUpdateForm.value.effectiveDateFormControl),        
        "areaOfExpertise": this.selectedAOEOptionsValue,
        "city": this.dataUpdateForm.value.cityFormControl,
        "fax": this.dataUpdateForm.value.faxFormControl,
        "isFormerAddressAvailable": this.dataUpdateForm.value.formerAddressFormControl,
        "isPanelOpenOrClose": this.dataUpdateForm.value.panelStatusFormControl,
        "isProviderPlanningToTerm": this.dataUpdateForm.value.planTermFormControl,
        "languagesForProviderStaff": this.staffProviderLanguageOptionsValue,
        "languagesForProviders": this.selectedProviderLanguageOptionsValue,
         "officeHours": this.selectedOfficeHoursValue,
        "phone": this.dataUpdateForm.value.phoneFormControl,
        "providerIds": this.selectedProviderIdValue,
        "state": this.dataUpdateForm.value.stateFormControl,
        "street": this.dataUpdateForm.value.streetFormControl,
        "suite": this.dataUpdateForm.value.suiteFormControl,
        "taxId": this.dataUpdateForm.value.taxidFormControl,
        "termDate": this.formatDate(this.dataUpdateForm.value.termDateFormControl),
        "zipCode": this.dataUpdateForm.value.zipCodeControl,
      } 
      //console.log("printing fileObj ---:",fileObj)
      if (this.dataUpdateForm.invalid) {
        const element = document.getElementById("mainContainerDiv");
        element.scrollTo(0,500);
        return;
    }
      this.providerDataUpdateService.savePDMDetails(fileObj).subscribe(resp => {
        let response :any= resp;    
      //console.log("PDM Data File upload response:",response, response.error.status);  
      if(response.error.status == 200) {
        alert("PDM Data submitted successfully .");
        this.clearForm();
        this.clearSelectOptions();
      }  
      else {
        alert("Something went wrong, please submit again! ");
      }      
      })         
    }
    formatDate(date: any) {
      if(!date)
        return '';
      date = date.replace(/-+/g, '-');
      var array = (date || '').toString().split(/\-/g);
      let dateFormat = array[1]+ '/' + array[2] + '/' + array[0];
      return dateFormat;
    };
  
  loadMetadata(){
    this.getLanguageAndAOEDetails();
    // this.getOfficeHours();
  }
  getLanguageAndAOEDetails(){
    this.showSpinner = true;
    this.providerDataUpdateService
      .getLanguageAndAOEDetails()
      .subscribe(data => {
        if(data){
          if(data.areaOfExpertise){
            this.aoeOptions = this.convertObjectToMultiSelectDataModel(data.areaOfExpertise);
            //console.log("aoeOptions values---:",this.aoeOptions)
          }
          if(data.Language){
            this.providerLanguageOptions = this.convertObjectToMultiSelectDataModel(data.Language);
            this.staffLanguageOptions = this.convertObjectToMultiSelectDataModel(data.Language);
          }
          this.showSpinner = false;
        }
      },error => {this.showSpinner = false;});
  }
  getOfficeHours(){
    this.providerDataUpdateService
    .GetProviderDetailsFromEDH()
    .subscribe(data => {
      if(data){
        if(data.responseDatasArray){
          this.officeHoursOptions = this.convertObjectToOfficeHOursDataModel(data.providerOfficeHours);
        }
      }
    });
  }

  getProviderInfo() {
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.userSiteProviders.replace(
      '{id}',
      username
    );
    // this.showSpinner = true;
    this.list = [];
    const dataModelList = [];
    this.cupService.retrieveData('post', url).subscribe(
      data => {
        if (data != null) {
          data.map(element => {
            if(element.providers && element.providers.length>0){
              element.providers.map(async each => {
                    let obj = null;
                    {
                      obj = {
                        value: each.name +
                        "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                        each.address +
                        "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                        each.providerId +
                        "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                        each.npi ,
                        //label: each.providerId
                        label: each.name +
                        "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                        each.address                        
                      };
                    }
                    if (obj && obj.value && obj.label) {
                      if(!dataModelList.some(x => x.value == obj.value)){
                        dataModelList.push(obj);
                        this.provierIdOptions.push(obj);
                        //console.log("provierIdOptions---:",this.provierIdOptions)
                      }
                    }
                });
            }
          })
        }
      },
      error => {
        this.showSpinner = false;
      }
    );
  }
  dataFilter() {
    this.list = this.copyOfList.filter( element => {
      if ((element.data.name.toUpperCase().includes(this.searchInput.toUpperCase()) || element.data.npi.includes(this.searchInput))) {
        return element;
      }
  });
  }
   filterMember(event:any) {
    this.dataFilter();
    var filterItems = $('.providerDataTable tr').length;
    //console.log('this.searchInput ',this.searchInput);
    if (filterItems < 10 && this.searchInput) {
      $('.paginationTab').hide();
    }
    else{
    $('.paginationTab').show();
    }
  }
//   rowSelection(providerInfo){
//     console.log(providerInfo);
//     let url= 'https://ca47twvcup003.caremore.com:6443/#/providerdataupdate/' + this.campaignId + '/'+this.instanceId + '/'+ providerInfo.data.providerId + '/' +this.mode + '/'+ this.recall;
//     window.open(url,'_blank');

//   }
//   viewMore(providerInfo, event?: any){
//      if(((event &&(event.target.outerHTML.includes('primaryaddress'))) || (!((event &&(event.target.outerHTML.includes('forExpand')))|| (event &&(event.target.outerHTML.includes('forCollapse'))))))){
//     let url= 'https://ca47twvcup003.caremore.com:6443/#/providerdataupdate/' + this.campaignId + '/'+this.instanceId + '/'+ providerInfo.data.providerId + '/' +this.mode + '/'+ this.recall;
//     window.open(url,'_blank');
    
//   } else {
//     providerInfo['expand'];
//     }
// }
private convertObjectToMultiSelectDataModel(responseDataList) {
  try {
    const dataModelList = [];
    if (responseDataList && responseDataList.length > 0) {
      responseDataList.forEach((x, index) => {
        let obj = null;
        {
          obj = {
            value: x.ID,
            label: x.Description
          };
        }
        if (obj && obj.value && obj.label) {
          dataModelList.push(obj);
        }
      });
    }
    return dataModelList;
  } catch (err) {
    throw err;
  }
}
private convertObjectToOfficeHOursDataModel(responseDataList) {
  try {
    const dataModelList = [];
    if (responseDataList && responseDataList.length > 0) {
      responseDataList.forEach((x, index) => {
        let obj = null;
        {
          obj = {
            value: x.ID,
            label: x.day + '-' + x.officeStartTimeFirst + '-' + x.officeEndTimeFirst
          };
        }
        if (obj && obj.value && obj.label) {
          dataModelList.push(obj);
        }
      });
    }
    return dataModelList;
  } catch (err) {
    throw err;
  }
}
getSettings(placeholder: string) {
  try {
    return {
      enableCheckAll: false,
      enableSearchFilter: true,
      badgeShowLimit: 1,
      maxHeight: 160,
      // lazyLoading: true,
      singleSelection: false,
      showCheckbox: true,
    };
  } catch (err) {
    throw err;
  }
}
changeNewPDM() {
  this.NewPDM = true;
  console.log("clicking pDM")
}
changeOldPDM() {
  this.NewPDM = false;
  console.log("clicking old pDM")
}
}
